import { Observable, of, switchMap } from 'rxjs';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { ChatInitializer } from '../initializers';
import { inject } from '@angular/core';
import { AppRoutes } from '@core';
import { ActiveChannelModel } from '../interfaces';
import { PENDING_USER_ID_QUERY_PARAM } from '../constants';

export const isChannelLoadedGuard = (route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> => {
  const chatInitializer: ChatInitializer = inject(ChatInitializer);
  const router: Router = inject(Router);

  const pendingUserId: string | null = route.queryParamMap.get(PENDING_USER_ID_QUERY_PARAM);
  if (pendingUserId) return of(true);

  return chatInitializer.activeChannelData$.pipe(
    switchMap((activeChannel: ActiveChannelModel) => {
      if (!activeChannel) return of(router.createUrlTree([AppRoutes.MESSAGES]));

      return of(true);
    })
  );
};
